<!--
 * @Author: your name
 * @Date: 2020-09-04 15:31:43
 * @LastEditTime: 2020-11-10 09:51:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\question\answer_area\correction_answer_area.vue
-->
<template>
  <div class="answer_area">
    <div class="left">
    <div class="nav">
      
      <!-- 展示方式 -->
      <div class="btns">
        <span style="float:left;font-size:24px;">作答完成后请点击对勾进行保存</span>
        <el-button
          :disabled="isDisable"
          :circle="true"
          :style="{'background-color' : tab == 5 ? '#ff5a00' : '#5c307d'}"
          @click="keepImage"
        >
          <img src="@/assets/images/paper/correction_answer/enter.png" alt />
        </el-button>
      </div>
    </div>
    <div class="answer">
      <div :id="`tui-editor-${this.question.id}`" style="margin-left:50px;background-color : #f6eeff;"></div>
    </div>
    </div>
    <div class="right"></div>
  </div>
</template>


<script>
import html2canvas from "html2canvas";
import ImageEditor from 'tui-image-editor'
import $ from "jquery";
import questionHandle from "@/assets/js/question-handle";
export default {
  data() {
    return {
      tab: 0,
      img_url: "",
      instance: null,
      backURL: this.$config.backURL,
    };
  },
  props: {
    question: {
      type: Object,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isComposite: {
      type: Boolean,
      default: false,
    },
    //是否显示自答答案
    isShowSelfAnswer :{
      type: Boolean,
      default: false,
    },
    qTab: {  // 错题本添加判断监听是否展示
      type: Number,
      default: 0,
    }
  },
  methods: {
    formatQuestion(ques) {
      this.question = questionHandle.formatQuestion(ques);
    },
    clickMode(param) {
      this.tab = param;
    },
    keepImage() {
      // 获取到的图片数据
      try {
        this.img_url = this.instance.toDataURL();
        let testId =  window.localStorage.getItem("test_id");
        let correctImgByTestId = {
          testId :testId,
          img : this.img_url,
          qid: this.question.id
        } 
        window.localStorage.setItem(`correctImgByTestId-${this.question.id}`, JSON.stringify(correctImgByTestId));
        
        let html_img = `<img width="1290px" src="${this.img_url}" />`;
        let correct = false;//专观题为false
        let score = 0;
        //赋值进当前的q的信息对象
        this.$root.eventHub.$emit(
          "answer-status-changed",
          this.question.typeCode,
          this.question.score,
          true,
          this.question.original,
          html_img,
          score,
          correct,
          false
        );
        this.$message({
          type : 'success',
          message : '提交图片成功!'
        });
      } catch (error) {
        this.$message({
          type : 'error',
          message : '提交图片失败,请重试!'
        });
      }
    
    }
  },
  mounted() {
  this.$root.eventHub.$on("question-tab-changed", (qTab) => {
    if (qTab == this.question.original) {
      const locale_zh_cn = { // override default English locale to your custom
        'Apply': '确定',
        'Cancel': '取消',
        //主菜单
        'Crop': '裁剪',
        'DeleteAll': '删除全部',
        'Delete': '删除',
        'Undo': '撤销',
        'Redo': '撤销返回',
        'Reset': '重置',
        'Flip': '翻转',
        'Rotate': '旋转',
        'Draw': '画笔',
        'Shape': '形状',
        'Icon': '图标',
        'Text': '文本(双机)',
        'Mask': '遮罩',
        'Filter': '滤镜',
        'Load': '打开',
        'Download': '下载',
        //滤镜工具栏
        'Grayscale': '灰度',
        'Invert': '反转',
        'Sepia': '褐色',
        'Sepia2': '褐色',
        'Blur': '模糊',
        'Sharpen': '锐化',
        'Emboss': '浮雕',
        'Remove White': '去除白色',
        'Distance': '距离',
        'Brightness': '亮度',
        'Noise': '降噪',
        'Pixelate': '马赛克',
        'Color Filter': '滤色',
        'Threshold': '阈',
        //遮罩工具栏
        'Tint': '色调',
        'Multiply': '叠加',
        'Blend': '混合',
        'Load Mask Image': '载入遮罩图片',
        //文本工具栏
        'Bold': '粗体',
        'Italic': '斜体',
        'Underline': '下划线',
        'Left': '左对齐',
        'Center': '居中对齐',
        'Right': '右对齐',
        'Color': '颜色',
        'Text size': '字体大小',
        //图标工具栏
        'Arrow': '箭头',
        'Arrow-2': '箭头2',
        'Arrow-3': '箭头3',
        'Star-1': '星形1',
        'Star-2': '星形2',
        'Polygon': '多边形',
        'Location': '位置',
        'Heart': '心形',
        'Bubble': '气泡',
        'Custom icon': '自定义图标',
        //形状工具栏
        'Rectangle': '矩形',
        'Circle': '圆',
        'Triangle': '三角形',
        'Fill': '填充色',
        'Stroke': '线型',
        //画笔工具栏
        'Free': '自由画',
        'Straight': '直线',
        'Range': '范围',
        //翻转工具栏
        'Flip X': '水平翻转',
        'Flip Y': '竖直翻转',
        //裁剪工具栏
        'Custom': '自定义',
        'Square': '方形',
        // etc...
      };
      const urlImage = require('../../../../assets/images/login/logo-min.png')
      var blackTheme = {
        'common.bi.image': urlImage,
        'common.bisize.width': '108px',
        'common.bisize.height': '108px',
        'common.backgroundImage': 'none',
        'common.backgroundColor': '#1e1e1e',
        'common.border': '0px',

        // header
        'header.backgroundImage': 'none',
        'header.backgroundColor': 'transparent',
        'header.border': '0px',

        // load button
        'loadButton.backgroundColor': '#fff',
        'loadButton.border': '1px solid #ddd',
        'loadButton.color': '#222',
        'loadButton.fontFamily': '\'Noto Sans\', sans-serif',
        'loadButton.fontSize': '12px',
        'loadButton.display': 'none',

        // download button
        'downloadButton.backgroundColor': '#fdba3b',
        'downloadButton.border': '1px solid #fdba3b',
        'downloadButton.color': '#fff',
        'downloadButton.fontFamily': '\'Noto Sans\', sans-serif',
        'downloadButton.fontSize': '12px',
        'downloadButton.display': 'none',

        // main icons
        'menu.normalIcon.color': '#8a8a8a',
        'menu.activeIcon.color': '#555555',
        'menu.disabledIcon.color': '#434343',
        'menu.hoverIcon.color': '#e9e9e9',
        'menu.iconSize.width': '24px',
        'menu.iconSize.height': '24px',

        // submenu icons
        'submenu.normalIcon.color': '#8a8a8a',
        'submenu.activeIcon.color': '#e9e9e9',
        'submenu.iconSize.width': '32px',
        'submenu.iconSize.height': '32px',

        // submenu primary color
        'submenu.backgroundColor': '#1e1e1e',
        'submenu.partition.color': '#3c3c3c',

        // submenu labels
        'submenu.normalLabel.color': '#8a8a8a',
        'submenu.normalLabel.fontWeight': 'lighter',
        'submenu.activeLabel.color': '#fff',
        'submenu.activeLabel.fontWeight': 'lighter',

        // checkbox style
        'checkbox.border': '0px',
        'checkbox.backgroundColor': '#fff',

        // range style
        'range.pointer.color': '#fff',
        'range.bar.color': '#666',
        'range.subbar.color': '#d1d1d1',

        'range.disabledPointer.color': '#414141',
        'range.disabledBar.color': '#282828',
        'range.disabledSubbar.color': '#414141',

        'range.value.color': '#fff',
        'range.value.fontWeight': 'lighter',
        'range.value.fontSize': '11px',
        'range.value.border': '1px solid #353535',
        'range.value.backgroundColor': '#151515',
        'range.title.color': '#fff',
        'range.title.fontWeight': 'lighter',

        // colorpicker style
        'colorpicker.button.border': '1px solid #1e1e1e',
        'colorpicker.title.color': '#fff'
      };

      this.$nextTick(() => {
        let imgHeight = document.getElementById(`gaicuo-${this.question.id}`).offsetHeight + 200
        let imgWidth = document.getElementById(`gaicuo-${this.question.id}`).offsetWidth - 100
        this.instance = new ImageEditor(document.querySelector(`#tui-editor-${this.question.id}`), {
            includeUI: {
              loadImage: {
                path: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                name: 'Blank'
              },
              menu: ['draw'],
              locale: locale_zh_cn,
              theme: blackTheme, // or whiteTheme
              initMenu: 'draw',
              menuBarPosition: 'bottom',
              uiSize: {
                width: '100%',
                height: `${imgHeight}px`
              },
            },
            cssMaxWidth: imgWidth,
            cssMaxHeight: 700,
            selectionStyle: {
              cornerSize: 20,
              rotatingPointOffset: 70
            },
            useDefaultUI: true
        });
        let _this = this;
        window.pageYoffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        if(!this.isShowSelfAnswer){
        let testId =  window.localStorage.getItem("test_id")
        let correctObj = JSON.parse(window.localStorage.getItem(`correctImgByTestId-${this.question.id}`)) || ''
        setTimeout(() => {
          if(correctObj.img != null && correctObj.img && correctObj.testId == testId && correctObj.qid == this.question.id){
            // let imgUrl = `<img width="1290px" src="${correctObj.img}" />`
            _this.url = correctObj.img
            _this.instance.loadImageFromURL(correctObj.img, 'html2canvasw').then(result => {
                console.log('old : ' + result.oldWidth + ', ' + result.oldHeight);
                console.log('new : ' + result.newWidth + ', ' + result.newHeight);
                $('.tie-btn-deleteAll, .tie-btn-reset, .tui-image-editor-download-btn').hide()
              });
          } else {
            html2canvas(document.getElementById(`gaicuo-${this.question.id}`)).then(cv => {
              let bk = cv.toDataURL("image/jpeg", 0.8);
              _this.url = bk
              _this.instance.loadImageFromURL(bk, 'html2canvas').then(result => {
                  console.log('old : ' + result.oldWidth + ', ' + result.oldHeight);
                  console.log('new : ' + result.newWidth + ', ' + result.newHeight);
                  $('.tie-btn-deleteAll, .tie-btn-reset, .tui-image-editor-download-btn').hide()
              });
            });
          }
        })
        }else{
          setTimeout(() => {
            html2canvas(document.getElementById(`gaicuo-${this.question.id}`)).then(cv => {
              let bk
              let correctObj = JSON.parse(window.localStorage.getItem('correctImgByTestId')) || ''
              if (correctObj.qid == this.question.id) {
                bk = correctObj.img
              } else if (this.question.self_answer != null && this.question.self_answer.indexOf('img') == -1) {
                bk = `${this.backURL}${this.question.self_answer}`
              } else if (this.question.self_answer != null && this.question.self_answer.indexOf('img') != -1) {
                var patt = /<img[^>]+src=['"]([^'"]+)['"]+/g;
                var result = [],
                  temp;
                while ((temp = patt.exec(this.question.self_answer)) != null) {
                  result.push({'url':temp[1]});
                }
                bk = result[0].url
              } else {
                bk = cv.toDataURL("image/jpeg", 0.8);
              }
              _this.url = bk
              _this.instance.loadImageFromURL(bk, 'html2canvas').then(result => {
                  console.log('old : ' + result.oldWidth + ', ' + result.oldHeight);
                  console.log('new : ' + result.newWidth + ', ' + result.newHeight);
                  $('.tie-btn-deleteAll, .tie-btn-reset, .tui-image-editor-download-btn').hide()
              });
            });
          })
        }
      })
    }
    })
  },
  destroyed () {
    localStorage.removeItem('correctImgByTestId')
    localStorage.removeItem(`correctImgByTestId-${this.question.id}`)
  }
};
</script>

<style lang="scss">
/deep/ .loading_color{
  .el-icon-loading {
    color: #5c307d !important;
    font-size: 60px !important;
  }
}
</style>

<style lang="stylus" scoped>
@import '../../../../assets/css/tui/imageEditPick.css';
@import '../../../../assets/css/tui/imageEdit.css';

.answer_area {
  margin-top : -9px;
  width: 1534px;
  background-color: #ffffff;
  position: relative;
  margin-left: 60px;
  // min-height : 620px;
  background-color : #f6eeff;
  border: 1px solid #e8c9ff;
  border-top : none;
  // border-right : 3px solid #e8c9ff;
  padding-bottom : 30px;
  margin-bottom : 30px;
  border-radius : 0 0 25px 25px;
  background-image: linear-gradient(to top, #decad8,#f6eeff,#f6eeff,#f6eeff,#f6eeff,#f6eeff,#f6eeff,#f6eeff);
  height: auto;
 .left{
    // position : absolute;
    // height : 320px;
    // min-height : 320px;
    height: auto;
    border-top : 2px solid #e8c9ff;
  }
  .nav {
    background-color : #f6eeff;
    width: 1394px;
    height: 70px;
    position: relative;
    // float: left;
    // border-bottom: 1px #5c307d solid;

    .text {
      height: 70px;
      width: 150px;
      font-size: 24px;
      color: #3c3c3c;
      line-height: 70px;
      position: relative;
      float: left;
    }

    .btns {
      height: 50px;
      line-height: 50px;
      color: #7eb8ff;
      text-align: center;
      padding-right: 20px;
      margin-top: 10px;
      float: right;

      >>> .el-button {
        height: 50px;
        width: 50px;
        background-color: #5c307d;
        color: #ffffff;
        font-size: 24px;
        float: left;
        margin-left: 10px;

        img {
          height: 25px;
          width: 25px;
        }
      }
    }
  }

  .answer {
    width: 1394px;
    height: auto;
  }
}
</style>